export const PROFILE_DETAILS = 'PROFILE_DETAILS';
export const SPORTS = 'SPORTS';
export const COUNTRIES = 'COUNTRIES';
export const PROFILE_LOADING = 'PROFILE_LOADING';

export const INIT_STATE = {
	profile: {},
    sports: [],
    countries: []
}


// WEBPACK FOOTER //
// ./src/profile/constants/index.js